module.exports = __webpack_public_path__ + "static/media/fac11.0b3e6f20.jpg";